import {Navigate, Outlet} from "react-router-dom";
import {useAppContext} from "../../contexts/AppContext";

// Д1: достъп до админ панела само за роля 'admin'. Панелът вече е зад
// глобалния RouteGuard (логнат потребител), затова тук проверяваме само ролята.
// Докато потребителят се зарежда (AppContext дърпа /user) → null, за да не
// пренасочваме преждевременно.
export const AdminRouteGuard = ({children}) => {
    const {user} = useAppContext();
    if (!user || !user.username) return null;
    if (user.role !== 'admin') return <Navigate to="/" replace/>;
    return children ? children : <Outlet/>;
};
